//auth
export const AUTH_GUARD_SYSTEM = "web";
export const AUTH_GUARD_STORE = "store";
export const AUTH_GUARD_RETAILER = "retailer";
export const AUTH_GUARD_CLIENT = "client";

